module.exports = __webpack_public_path__ + "static/media/bg.e3fbbf2a.png";